// web/mocks/react-native-image-picker.ts

export type ImagePickerResponse = {
    didCancel?: boolean;
    errorCode?: string;
    errorMessage?: string;
    assets?: Array<{
      uri: string;
      fileName?: string;
      type?: string;
      width?: number;
      height?: number;
      fileSize?: number;
    }>;
  };
  
  export const launchCamera = (
    _options: any,
    callback: (response: ImagePickerResponse) => void
  ) => {
    console.warn("launchCamera is not supported on web. Returning mock.");
    callback({
      didCancel: true,
      errorMessage: "Camera not available on web",
    });
  };
  
  export const launchImageLibrary = (
    _options: any,
    callback: (response: ImagePickerResponse) => void
  ) => {
    console.warn("launchImageLibrary is not supported on web. Returning mock.");
    callback({
      didCancel: true,
      errorMessage: "Image library not available on web",
    });
  };
  
  // In case you import `ImagePicker` namespace
  export default {
    launchCamera,
    launchImageLibrary,
  };
  